import { IEnvironment } from "./environment";

export const stagingEnv: IEnvironment = {
  env: "staging",
  api: {
    protocol: "http",
    host: "aurora-api.apps.ocp11.topnet.rs",
  },
};
